<template>
    <b-card>
      <div class="card-header">
        <ul class="nav nav-pills card-header-pills">

          <li class="nav-item">
            <a class="nav-link disabled">Lockgroups</a>
          </li>
          <li class="nav-item">
            <div>
              <b-button v-on:click="addToLockGroup()" variant="primary" style="background-color:orange !important; color:#fff;">
                <i class="fa fa-plus-circle"></i> Assign
              </b-button>

            </div>
          </li>
        </ul>
      </div>
      <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="lockGroups" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter">
        <template slot="action" slot-scope="data">
            <b-button type="button" variant="primary" @click.stop="showModal(modalId(data.item.id), $event.target)" style="float: left;margin-right: 5px;">
              <i class="fa fa-edit"></i>
              Edit
            </b-button>

            <b-button type="button" variant="danger" @click.stop="showModal(modalDeleteId(data.item.id), $event.target)">
              <i class="fa fa-trash-o"></i>
              Delete
            </b-button>
        </template>
</b-table>
<nav>
  <b-pagination :total-rows="getRowCount(lockGroups)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
</nav>
<div v-for="lockLG in lockGroups" :key="lockLG.id">
  <b-modal ok-only ok-variant="secondary" ok-title="Cancel" :id="modalId(lockLG.id)">
    <lock-group-edit-form :lockGroupId=lockLG.id></lock-group-edit-form>
  </b-modal>

  <b-modal :id="modalDeleteId(lockLG.id)" @ok="handleOk(lockLG.id)" centered>
    <div class="modal-window">
      <div class="alert alert-danger">
        <ul class="fa-ul" style="margin-bottom: 0px;">
          <li>
            <i class="fa fa-info-circle fa-li"></i>
            <p>Are you sure you want to remove current lock from lockgroup:<br/> <strong>{{ lockLG.name }}</strong> ?</p>
          </li>
        </ul>
      </div>

    </div>
  </b-modal>
</div>
</b-card>
</template>

<script>
import LockGroupEditForm from '@/views/base/haus/LockGroupEditForm'

let qs = require('qs')
const constants = require('../shared/constants')
const BASE = constants.NEWPORT_CONST.API_URL
const API = BASE + '/api/lockgroups/detailForLock'
const API_DELETE_LG = BASE + '/api/lockGroupMappers/delete'

function postdata (url, data) {
  return fetch(url, {
    body: qs.stringify(data),
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
      'accessToken': data.accessToken
    },
    method: 'POST'
  })
    .then(res => res.json())
}

async function getData (lockId) {
  let parameters = {
    client_id: constants.NEWPORT_CONST.CLIENT_ID,
    client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
    accessToken: localStorage.getItem('token'),
    lockId: lockId
  }

  let res = await postdata(API, parameters)
  return res.lockGroup
}

async function deletelg (groupId, lockId) {
  let parameters = {
    client_id: constants.NEWPORT_CONST.CLIENT_ID,
    client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
    accessToken: localStorage.getItem('token'),
    lockGroupId: groupId,
    lockId: lockId
  }
  let res = await postdata(API_DELETE_LG, parameters)
  return res.mapperId
}

export default {
  name: 'lock-group-for-lock',
  components: {
    LockGroupEditForm
  },
  props: ['locationName', 'locationId', 'locationDescription', 'lockId'],
  data: () => {
    return {
      lockGroups: [],
      fields: {
        name: {
          label: '<i class="icon-layers"></i>'
        },
        action: {
          label: '<i class="icon-menu"></i>'
        }
      },
      currentPage: 1,
      perPage: 5,
      totalRows: 0,
      filter: null
    }
  },
  mounted () {
    getData(this.$route.params.lockId).then(response => {
      this.$data.lockGroups = response
    })
  },
  methods: {
    modalId (i) {
      return 'modal' + i
    },
    modalDeleteId (i) {
      return 'modaldellg' + i
    },
    mailto (email) {
      return 'mailto:' + email
    },
    openlink (link) {
      location.href = link
    },
    openlinkwithlocid (link, anId) {
      let uri = link + anId
      location.href = uri
    },
    getRowCount (items) {
      return items.length
    },
    del (groupId, locId) {
      deletelg(groupId, locId)
      location.reload()
    },
    addToLockGroup () {
      location.href = '/#/base/lockgroupListAddLock/' + this.$route.params.lockId
    },
    handleOk (id) {
      let lockId = this.$route.params.lockId
      deletelg(id, lockId)
      location.reload()
    },
    showModal (id, button) {
      this.$root.$emit('bv::show::modal', id, button)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/base/haus/LockGroupForLock.vue